module.exports = __webpack_public_path__ + "img/img_34@2x.445c6c48.png";